<template>
	<CardBase 
		ref="card" 
		:app="app"
		:card="card" 
		:loading="loading" 
		:message="message"
		:actions="actions" 
		@action="handleAction">

		<template #title>
			Select options for refine process.
		</template>

		<template v-if="isOutage || isLegacy" #status>
			<AtomStatus 
                :level="statusLevel"
                :status="statusMessage" />
		</template>

		<template #content>
			<div class="card-optimize">

				<div
					class="scrollable"
					ref="optionsScrollable"
					@wheel.stop
					@touchmove.stop>

					<!-- Polygons -->
					<div class="group">
						<div class="heading">
							<div class="name">
								Polygons
							</div>
							<div class="value">
							</div>
						</div>
						<!--<div class="option">
							<div class="name">
								<v-tooltip location="right" text="polygon type of the resulting model">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Type</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-btn-toggle 
									mandatory 
									color="color1" 
									class="toggle" 
									elevation="0" 
									density="comfortable"
									v-model="polygonType">
									<v-btn value="triangles" class="toggle-button">
										<v-icon icon="fa-solid fa-circle-nodes"></v-icon>
										<span>Triangles</span>
									</v-btn>
									<v-btn value="quads" class="toggle-button" :disabled="true">
										<v-icon icon="fa-solid fa-square"></v-icon>
										<span>Quads</span>
									</v-btn>
									<v-btn value="voxels" class="toggle-button">
										<v-icon icon="fa-solid fa-cube"></v-icon>
										<span>Voxels</span>
									</v-btn>
								</v-btn-toggle>
							</div>
						</div>-->
						<div class="option"><!-- v-if="isPolygonTriangles || isPolygonQuads" -->
							<div class="name">
								<v-tooltip location="right" :text="polygonCountText">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Count</span>
											<v-icon v-if="tooFewPolygons" color="warning" icon="fa-solid fa-triangle-exclamation"></v-icon>
											<v-icon v-else icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-slider 
									class="slider"
									tick-size="2" 
									show-ticks="always" 
									v-model="polygonCount" 
									:min="polygons10"
									:max="polygons" 
									:step="step"
									:ticks="polygonCountTicks" 
									:color="polygonCountColor">
									<template v-slot:append>
										<v-text-field 
											hide-details
											class="slider-field" 
											color="color1"
											density="compact"
											variant="outlined" 
											v-model="polygonCount" 
											@keydown.stop
											@keypress.stop
											@keyup.stop>
										</v-text-field>
									</template>
								</v-slider>
							</div>
						</div>
						<!--<div v-else class="option">
							<div class="name">
								<v-tooltip location="right" text="resolution of voxel grid">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Resolution</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-slider 
									thumb-label
									min="8"
									max="64"
									step="4"
									color="color1" 
									class="slider"
									tick-size="2" 
									show-ticks="always" 
									v-model="polygonResolution" 
									:ticks="polygonResolutionTicks">
								</v-slider>
							</div>
						</div>-->
					</div>
					
					<!-- Keep Largest -->
					<div class="group">
						<div class="heading">
							<div class="name">
								Keep Largest
							</div>
							<div class="value">
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="when activated, keeps only the largest connected meshes">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Active</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-switch
									hide-details 
									color="color1" 
									class="switch" 
									v-model="keepLargestActive">
								</v-switch>
							</div>
						</div>
						<Transition name="option-toggle">
							<div v-if="keepLargestActive" class="option">
							<div class="name">
								<v-tooltip location="right" text="count of meshes to keep">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Count</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-number-input 
									hide-details 
									color="color1"
									controlVariant="default" 
									v-model="keepLargestCount"
									:reverse="false"
									:hideInput="false"
									:inset="false" 
									:min="1" 
									@keydown.stop
									@keypress.stop
									@keyup.stop>
								</v-number-input>
							</div>
						</div>
						</Transition>
					</div>
					
					<!-- Fill Holes -->
					<!--
					<div class="group">
						<div class="heading">
							<div class="name">
								Fill Holes
							</div>
							<div class="value">
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="when activated, fills holes in the mesh">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Active</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-switch 
									hide-details 
									color="color1" 
									class="switch" 
									v-model="fillHolesActive">
								</v-switch>
							</div>
						</div>
						<!-<Transition name="option-toggle">
							<div v-if="fillHolesActive" class="option">
							<div class="name">
								<v-tooltip location="right" text="maximum size of holes to fill (in percentage of model size)">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Limit</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-slider 
									thumb-label
									min="0.0"
									max="1.0"
									step="0.05"
									color="color1" 
									class="slider"
									tick-size="2" 
									show-ticks="always" 
									v-model="fillHolesLimit" 
									:ticks="defaultTicks">
								</v-slider>
							</div>
						</div>
						</Transition>->
					</div>
					-->

					<!-- Smooth Surface -->
					<!--
					<div class="group">
						<div class="heading">
							<div class="name">
								Smooth Surface
							</div>
							<div class="value">
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="when activated, smooths the surface of the mesh">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Active</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-switch 
									hide-details 
									color="color1" 
									class="switch" 
									v-model="smoothSurfaceActive">
								</v-switch>
							</div>
						</div>
						<Transition name="option-toggle">
							<div v-if="smoothSurfaceActive" class="option">
							<div class="name">
								<v-tooltip location="right" text="strength of the surface smoothing">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Strength</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-slider 
									thumb-label
									min="0.0"
									max="1.0"
									step="0.05"
									color="color1" 
									class="slider"
									tick-size="2" 
									show-ticks="always" 
									v-model="smoothSurfaceStrength" 
									:ticks="defaultTicks">
								</v-slider>
							</div>
						</div>
						</Transition>
					</div>
					-->

					<!-- Clip Side -->
					<!--
					<div class="group">
						<div class="heading">
							<div class="name">
								Clip Side
							</div>
							<div class="value">
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="when activated, clips the specified side of the mesh">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Active</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-switch 
									hide-details 
									color="color1" 
									class="switch" 
									v-model="clipSideActive">
								</v-switch>
							</div>
						</div>
						<Transition name="option-toggle">
							<div v-if="clipSideActive" class="option">
							<div class="name">
								<v-tooltip location="right" text="side to clip from the mesh">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Side</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-btn-toggle 
									mandatory 
									color="color1" 
									class="toggle" 
									elevation="0" 
									density="comfortable"
									v-model="clipSideAxis">
									<v-btn value="top" class="toggle-button">
										<span>top</span>
									</v-btn>
									<v-btn value="bottom" class="toggle-button">
										<span>bottom</span>
									</v-btn>
									<v-btn value="left" class="toggle-button">
										<span>left</span>
									</v-btn>
									<v-btn value="right" class="toggle-button">
										<span>right</span>
									</v-btn>
									<v-btn value="front" class="toggle-button">
										<span>front</span>
									</v-btn>
									<v-btn value="back" class="toggle-button">
										<span>back</span>
									</v-btn>
								</v-btn-toggle>
							</div>
						</div>
						</Transition>
						<Transition name="option-toggle">
							<div v-if="clipSideActive" class="option">
							<div class="name">
								<v-tooltip location="right" text="fraction to clip from the specified side (in percentage of model size)">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Fraction</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-slider 
									thumb-label
									min="0.0"
									max="1.0"
									step="0.05"
									color="color1" 
									class="slider"
									tick-size="2" 
									show-ticks="always" 
									v-model="clipSidePercentage" 
									:ticks="defaultTicks">
								</v-slider>
							</div>
						</div>
						</Transition>
					</div>
					-->

					<!-- Texture Maps -->
					<div v-if="texture" class="group">
						<div class="heading">
							<div class="name">
								Texture Maps
							</div>
							<div class="value">
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="lists existing texture maps">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Existing</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value value-textures">
								<span class="value-texture">
									<v-icon v-if="textureAlbedo" color="success" icon="fa-solid fa-check"></v-icon>
									<v-icon v-else color="error" icon="fa-solid fa-xmark"></v-icon>
									Albedo
								</span>
								<span class="value-texture">
									<v-icon v-if="textureMetallic" color="success" icon="fa-solid fa-check"></v-icon>
									<v-icon v-else color="error" icon="fa-solid fa-xmark"></v-icon>
									Metallness
								</span>
								<span class="value-texture">
									<v-icon v-if="textureRoughness" color="success" icon="fa-solid fa-check"></v-icon>
									<v-icon v-else color="error" icon="fa-solid fa-xmark"></v-icon>
									Roughness
								</span>
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="when activated, creates a normal map">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Normal</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-switch
									hide-details 
									color="color1" 
									class="switch" 
									v-model="normalMapActive">
								</v-switch>
							</div>
						</div>
						<div class="option">
							<div class="name">
								<v-tooltip location="right" text="when activated, creates a ambient occlusion map">
									<template #activator="{ props }">
										<div class="name-inner" v-bind="props">
											<span>Occlusion</span>
											<v-icon icon="fa-solid fa-info-circle"></v-icon>
										</div>
									</template>
								</v-tooltip>
							</div>
							<div class="value">
								<v-switch
									hide-details 
									color="color1" 
									class="switch" 
									v-model="occlusionMapActive">
								</v-switch>
							</div>
						</div>
					</div>

				</div>

			</div>
		</template>

		<template #side>
			<div class="asset">
				<div class="heading">Model</div>
				<div class="viewer">
					<ViewerImage :asset="primaryAsset" />
				</div>
			</div>
		</template>

	</CardBase>
</template>

<script>
import ASSETS from '@generio-ai/library-legacy/constants/assets'
import { mapGetters, mapActions } from '@generio-ai/library-legacy/plugins/vuex'
import { ViewerImage } from '@generio-ai/library-legacy/components/viewer'
import ACTION from '@/constants/action.js'
import CARD from '@/constants/card.js'
import AtomStatus from '@/components/common/atom/AtomStatus.vue'
import CardBase from '@/components/flow/cards/CardBase.vue'

export default {
	name: 'CardOptimize',
	components: {
		AtomStatus,
		ViewerImage,
		CardBase
	},
	props: {
		app: {
            type: String,
            required: true
        },
        card: {
            type: Object,
            required: true
        }
    },
	data() {
		return {
			loading: false,
			message: '',
			healthy: {
				model_optimize: true,
			}
		}
	},
	computed: {
		...mapGetters('auth', [
			'isAdministrator'
		]),
		...mapGetters('flows', [
			'isActiveByIndex',
			'isLastByIndex',
			'getPrimaryCardForCard'
        ]),

		isOutage() {
			return !this.healthy.model_optimize
		},
		isLegacy() {
			return this.version < 10
		},

		isActiveCard() {
			return this.isActiveByIndex(this.app, this.index)
		},
		isLastCard() {
            return this.isLastByIndex(this.app, this.index)
        },

		isPolygonTriangles() {
			return this.polygonType === 'triangles'
		},
		isPolygonQuads() {
			return this.polygonType === 'quads'
		},
		isPolygonVoxels() {
			return this.polygonType === 'voxels'
		},

		tooFewPolygons() {
			return this.polygonCount < this.polygons25
		},

		index() {
            return this.card.index
        },
		nextIndex(){
			return this.card.index + 1
		},
		category() {
			return this.card.category
		},
		prompt() {
			return this.card.prompt
		},
		promptQuality() {
			return this.prompt?.quality
		},

		primaryCard() {
			return this.getPrimaryCardForCard(this.app, this.card, false)
		},
		primaryAssets() {
			return this.primaryCard?.assets
		},
		primaryAsset() {
			return this.primaryCard?.getSelectedOrFirstAsset()
		},
		primaryFile() {
			return this.primaryAsset?.files?.[ASSETS.FILES.KEY.DEFAULT]
		},
		primaryDetails() {
			return this.primaryFile?.details
		},

		version() {
			return this.primaryAsset?.additional?.version || 0
		},

		texture() {
			return this.primaryDetails?.texture
		},
		textureAlbedo() {
			return this.primaryDetails?.texture_albedo ?? null
		},
		textureMetallic() {
			return this.primaryDetails?.texture_metallic ?? null
		},
		textureRoughness() {
			return this.primaryDetails?.texture_roughness ?? null
		},

		polygons() {
			return this.primaryDetails?.polygons || 100000
		},
		polygons75() {
			return Math.floor(this.polygons * 0.75)
		},
		polygons50() {
			return Math.floor(this.polygons * 0.5)
		},
		polygons25() {
			return Math.floor(this.polygons * 0.25)
		},
		polygons10() {
			return Math.floor(this.polygons * 0.1)
		},
		step() {
			return Math.floor(this.polygons / 20)
		},

		actions() {
			if ((this.isOutage && !this.isAdministrator) || this.isLegacy) return []
			return [
				ACTION.REFINE_MODEL
			]
		},

		statusLevel() {
			if (this.isLegacy) return 'warning'
            if (this.isOutage) return 'error'
            return 'healthy'
        },
        statusMessage() {
			if (this.isLegacy) return "Model version is outdated and not supported for refinement."
            if (this.isOutage) return "Model refinement service is currently unavailable."
            return "Model refinement service is healthy."
        },

		polygonType: {
			get() {
				return this.card.option?.polygonType || 'triangles'
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.polygonType = value
			}
		},
		polygonCount: {
			get() {
				const rawCount = this.card.option?.polygonCount
				let value = rawCount ?? this.polygons
				if (value < this.polygons10) {
					value = this.polygons10
					if (!this.card?.option) this.card.option = {}
					this.card.option.polygonCount = value
				}
				return value
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				const numericValue = Number(value)
				const safeValue = Number.isFinite(numericValue) ? Math.max(this.polygons10, Math.round(numericValue)) : this.polygons10
				this.card.option.polygonCount = safeValue
			}
		},
		polygonResolution: {
			get() {
				return this.card.option?.polygonResolution ?? 64
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.polygonResolution = value
			}
		},
		keepLargestActive: {
			get() {
				return this.card.option?.keepLargestActive ?? false
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.keepLargestActive = value
			}
		},
		keepLargestCount: {
			get() {
				return this.card.option?.keepLargestCount ?? 1
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.keepLargestCount = value
			}
		},
		fillHolesActive: {
			get() {
				return this.card.option?.fillHolesActive ?? false
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.fillHolesActive = value
			}
		},
		fillHolesLimit: {
			get() {
				return this.card.option?.fillHolesLimit ?? 0.1
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.fillHolesLimit = value
			}
		},
		smoothSurfaceActive: {
			get() {
				return this.card.option?.smoothSurfaceActive ?? false
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.smoothSurfaceActive = value
			}
		},
		smoothSurfaceStrength: {
			get() {
				return this.card.option?.smoothSurfaceStrength ?? 0.5
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.smoothSurfaceStrength = value
			}
		},
		clipSideActive: {
			get() {
				return this.card.option?.clipSideActive ?? false
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.clipSideActive = value
			}
		},
		clipSideAxis: {
			get() {
				return this.card.option?.clipSideAxis ?? 'bottom'
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.clipSideAxis = value
			}
		},
		clipSidePercentage: {
			get() {
				return this.card.option?.clipSidePercentage ?? 0.1
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.clipSidePercentage = value
			}
		},

		normalMapActive: {
			get() {
				return this.card.option?.normalMapActive ?? true
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.normalMapActive = value
			}
		},
		occlusionMapActive: {
			get() {
				return this.card.option?.occlusionMapActive ?? false
			},
			set(value) {
				if (!this.card?.option) this.card.option = {}
				this.card.option.occlusionMapActive = value
			}
		},

		polygonCountText() {
			if (this.tooFewPolygons) {
				return 'too few polygons may result in degraded quality'
			}
			return 'polygon count of the resulting optimized model'
		},
		polygonCountColor() {
			if (this.tooFewPolygons) return 'warning'
			return 'color1'
		},
		polygonCountTicks() {
			return {
				[this.polygons10]: '10%',
				[this.polygons25]: '25%',
				[this.polygons50]: '50%',
				[this.polygons75]: '75%',
				[this.polygons]: '100%'
			}
		},
		polygonResolutionTicks() {
			return [8, 16, 32, 64]
		},
		defaultTicks() {
			return [0.0, 0.25, 0.5, 0.75, 1.0]
		},
	},
	methods: {
		...mapActions('publics', [
			'fetchStatus'
		]),
		...mapActions('flows', [
			'newTransaction',
			'commitPrimitiveAsset',
			'fetchOptimizeModelMain',
		]),
		async updateStatus() 
		{
			// default is that the services are healthy
			this.healthy = {
				model_optimize: true,
			}

			try
			{
				// get status
				const status = await this.fetchStatus()

				// has healthy services
				if (status?.healthy) 
				{
					if (status.healthy.model_optimize === false) this.healthy.model_optimize = false
				}
			}
			catch (error)
			{
				// silent fail - if status check does not work, we still want to proceed
			}
		},		
		async handleAction(action) {
			if (action === null || action === undefined) return

			switch(action.id) 
			{
				case ACTION.REFINE_MODEL.id:
					this.newTransaction({
						app: this.app,
						card: this.card,
						taskCommit: this.commitPrimitiveAsset(),
						taskFetch: this.fetchOptimizeModelMain({
							component: CARD.MODEL,
							polygonCount: this.isPolygonTriangles || this.isPolygonQuads ? this.polygonCount : this.polygonResolution,
							polygonType: this.polygonType,
							keepLargestActive: this.keepLargestActive,
							keepLargestCount: this.keepLargestCount,
							fillHolesActive: this.fillHolesActive,
							fillHolesLimit: this.fillHolesLimit,
							smoothSurfaceActive: this.smoothSurfaceActive,
							smoothSurfaceStrength: this.smoothSurfaceStrength,
							clipSideActive: this.clipSideActive,
							clipSideAxis: this.clipSideAxis,
							clipSidePercentage: this.clipSidePercentage,
							normalMapActive: this.normalMapActive,
							occlusionMapActive: this.occlusionMapActive
						})
					})
					break
			}
		},
	},
	mounted() {
		this.updateStatus()
	}
}
</script>

<style>
.v-slider-thumb__label {
	background-color: rgb(var(--v-theme-darkbase));
	color: rgb(var(--v-theme-primary));
}

.slider-field {
	width: 80px;
}

.slider-field .v-field__input {
	padding: 8px !important;
	text-align: center;
}
</style>

<style scoped>
.option-toggle-enter-active,
.option-toggle-leave-active {
	transition: opacity 0.3s ease, max-height 0.3s ease;
	overflow: hidden;
}

.option-toggle-enter-from,
.option-toggle-leave-to {
	opacity: 0;
	max-height: 0;
}

.option-toggle-enter-to,
.option-toggle-leave-from {
	opacity: 1;
	max-height: 200px;
}

.card-optimize {
	width: 100%;
	height: 100%;
	max-height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
}

.card-optimize .scrollable {
	display: flex;
	flex-direction: column;
	gap: 1.5rem;
	overflow-y: auto;
	align-self: stretch;
	max-height: 100%;
	min-height: 0;
	padding: 2rem;
}

.card-optimize .group {
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
}
.card-optimize .group .heading {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
}

.card-optimize .group .heading .name {
	min-width: 180px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	font-size: 1.1rem;
	font-weight: bold;
}

.card-optimize .group .heading .value {
	flex-grow: 1;
	border-bottom: 1px solid rgb(var(--v-theme-shadow1));
}

.card-optimize .group .option {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
}

.card-optimize .group .option .name {
	min-width: 180px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-end;
	font-size: 1.0rem;
}

.card-optimize .group .option .name .name-inner {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 0.3rem;
}

.card-optimize .group .option .name .name-inner .v-icon {
	color: rgb(var(--v-theme-tertiary));
	font-size: 0.8rem;
	margin-top: 0.1rem;
}

.card-optimize .group .option .value {
	flex-grow: 1;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
}

.card-optimize .group .option .value-textures {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	min-height: 38px;
}

.card-optimize .group .option .value-texture {
	font-size: 0.9rem;
}

.asset {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 0.5rem;
}

.asset .viewer {
	width: 100%;
	display: block;
}

.card-optimize .toggle {
	width: 100%;
	display: flex;
	flex-direction: row;
	border: 1px solid rgb(var(--v-theme-lightbase));
}

.card-optimize .toggle-button {
	flex-grow: 1;
	flex-shrink: unset;
	background-color: rgb(var(--v-theme-darkbase));
}

.card-optimize .slider {
	margin-left: 15px;
	margin-right: 15px;
}

.card-optimize .switch {
	max-height: 38px;
	display: flex;
	align-items: center;
	justify-content: center;
}

@media (max-width: 800px) {
	.card-optimize .group .heading .name {
		min-width: 150px;
	}

	.card-optimize .group .option .name {
		min-width: 150px;
	}
}

@media (max-width: 600px) {
	.card-optimize .group {
		gap: 1rem;
	}

	.card-optimize .group .heading .name {
		min-width: unset;
	}

	.card-optimize .group .option {
		flex-direction: column;
		gap: 0.5rem;
	}

	.card-optimize .group .option .name {
		width: 100%;
		min-width: unset;
		justify-content: flex-start;
	}

	.card-optimize .group .option .value {
		width: 100%;
		min-width: unset;
		justify-content: flex-start;
	}
}
</style>